module.exports = __webpack_public_path__ + "static/media/21ECLAC16.dfa5ec01.jpg";